<template>
  <div>
    <div class="head row">
      <h3 class="pl-3">Betalingen</h3>
    </div>
    <div>
      <table class="table table-responsive table-hover">
        <thead>
          <tr>
            <th>Volgende betaling</th>
            <th>Factuurnummer</th>
            <th>Factuurbedrag</th>
            <th>Factuurdatum</th>
            <th>Datum betaald</th>
            <th></th>
          </tr>
        </thead>
        <thead></thead>
        <tbody>
          <tr v-for="(payment, index) in payments" :key="index">
            <td>{{ payment.next_payment_date | formatDate }}</td>
            <td>{{ payment.invoice_number }}</td>
            <td>{{ payment.amount }}</td>
            <td>{{ payment.invoice_date | formatDate }}</td>
            <td>{{ payment.payment_date | formatDate }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "index",
  components: {},
  computed: {},
  data() {
    return {
      payments: [],
    };
  },
  created() {
    this.getPayments();
  },
  methods: {
    getPayments() {
      this.$store
        .dispatch("get", `/api/v1/user-payments/${this.$route.params.id}`)
        .then((data) => {
          this.payments = data.data.data;
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
  },
  filters: {
    formatDate(value) {
      return moment(new Date(value)).format("DD-MM-YYYY");
    },
  },
};
</script>

<style scoped>
.small-size {
  font-size: 0.875rem !important;
}
</style>
